import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=aa10fe8e&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=ts&"
export * from "./Address.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa10fe8e",
  null
  
)

export default component.exports